import React, { useEffect, useState } from 'react';
import { Pagination as MUIPagination } from '@mui/material';
import { Box, createStyles, makeStyles } from '@material-ui/core';
import colors from '../../assets/styles/colors';
import commons from '../../assets/styles/commons';

interface Props {
  totalRecords: number;
  setCurrentPage: (page: number) => void;
  currentPage: number;
  rowsPerPage: number;
}

const useStyles = makeStyles(() =>
  createStyles({
    pagination: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    number: {
      fontFamily: commons.fontFamily,
      fontSize: 32,
      '&:hover': {
        color: colors.primary.orange,
        opacity: 0.8,
      },
    },
  }),
);

const Pagination: React.FC<Props> = ({
  totalRecords,
  setCurrentPage,
  currentPage,
  rowsPerPage,
}) => {

  const [canGoBack, setCanGoBack] = useState(false);
  const [canGoNext, setCanGoNext] = useState(true);
 
  const numberPages = Math.ceil(totalRecords / rowsPerPage);
  const onNextPage = () => setCurrentPage(currentPage + 1);
  const onPrevPage = () => setCurrentPage(currentPage - 1);

  const classes = useStyles();
  useEffect(() => {
    if (numberPages === currentPage) {
      setCanGoNext(false);
    } else {
      setCanGoNext(true);
    }

    if (currentPage === 1) {
      setCanGoBack(false);
    } else {
      setCanGoBack(true);
    }

  }, [numberPages, currentPage]);

  return (
    <>
      {numberPages > 1 && (
        <Box component="div" className={classes.pagination}>
          <MUIPagination
            count={numberPages}
            page={currentPage}
            color="primary"
            className={classes.number}
            onChange={(_, page) => setCurrentPage(page)}
          />
        </Box>
      )}
    </>
  );
};
 
export default Pagination;